import * as types from '../types';

export function loginRequest(payload) {
  return {
    type: types.LOGIN_REQUEST,
    payload,
  };
}

export function loginSucess(payload) {
  return {
    type: types.LOGIN_SUCCESS,
    payload,
  };
}

export function loginFailure(payload) {
  return {
    type: types.LOGIN_FAILURE,
    payload,
  };
}

export function userThemeChange(payload) {
  return {
    type: types.USER_THEME_CHANGE,
    payload,
  };
}

export function titleHeaderChange(payload) {
  return {
    type: types.TITLEHEADER_CHANGE,
    payload,
  };
}

export function dataLicencaChange(payload) {
  return {
    type: types.DATALICENCA_CHANGE,
    payload,
  };
}
